<ion-content scrollY="false">
  <ion-list lines="full">

    @if (permissionService.isPermitted('pos-people-store-credit-add-store-credit')) {
      <ion-item button="true" (click)="addStoreCredit()">
        <ion-label><fa-icon [icon]="['fal', 'plus']" size="lg" [fixedWidth]="true"></fa-icon>Add store credit</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-people-store-credit-remove-store-credit')) {
      <ion-item button="true" (click)="removeStoreCredit()">
        <ion-label><fa-icon [icon]="['fal', 'minus']" size="lg" [fixedWidth]="true"></fa-icon>Remove store credit</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-people-edit-person') && person.archived == false) {
      <ion-item button="true" (click)="archivePerson()">
        <ion-label><fa-icon [icon]="['fal', 'archive']" size="lg" [fixedWidth]="true"></fa-icon>Archive</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-people-edit-person') && person.archived == true) {
      <ion-item button="true" (click)="unarchivePerson()">
        <ion-label><fa-icon [icon]="['fal', 'archive']" size="lg" [fixedWidth]="true"></fa-icon>Unarchive</ion-label>
      </ion-item>
    }

    @if (permissionService.isPermitted('pos-people-edit-person')) {
      <ion-item button="true" (click)="edit()">
        <ion-label><fa-icon [icon]="['fal', 'pencil']" size="lg" [fixedWidth]="true"></fa-icon>Edit</ion-label>
      </ion-item>
    }

  </ion-list>
</ion-content>
